import React, { useState } from "react";
import ApplicationMaintenance from "./ApplicationMaintenance";
import PaymentGatewayMaintenance from "./PaymentGatewayMaintenance";

const MaintenanceSchedules = () => {
  const [tabKey, setTabKey] = useState(0);
  const [activeTab, setActiveTab] = useState("Application_Maintenance");

  const handleTabClick = (tabId) => {
    if (activeTab !== tabId) {
      setActiveTab(tabId);
      setTabKey((prevKey) => prevKey + 1); // Change key to force re-render
    }
  };
  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100 mb-4 ">
      <div className="overflow-auto">
        <ul
          className="nav nav-tabs tab-bg d-flex flex-nowrap overflow-auto"
          style={{ whiteSpace: "nowrap" }}
        >
          <li className="nav-item flex-shrink-0">
            <a
              href="#default-tab-1"
              data-bs-toggle="tab"
              className="nav-link active text-black"
              onClick={() => { handleTabClick("Application_Maintenance") }}
            >
              <span className="d-sm-none"> Application Maintenance</span>
              <span className="d-sm-block d-none  font-size-15 ">
                Application Maintenance
              </span>
            </a>
          </li>
          <li className="nav-item flex-shrink-0">
            <a href="#default-tab-2" data-bs-toggle="tab" className="nav-link  text-black" onClick={() => { handleTabClick("Payment_Gateway_Maintenance") }}>
              <span className="d-sm-none">Payment Gateway Maintenance</span>
              <span className="d-sm-block d-none  font-size-15 ">
                Payment Gateway Maintenance
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div className="tab-content panel rounded-0 p-3 m-0">
        <div className="tab-pane fade active show" id="default-tab-1">
          <ApplicationMaintenance key={tabKey} />
        </div>
        <div className="tab-pane fade" id="default-tab-2">
          <PaymentGatewayMaintenance key={tabKey} />
        </div>
      </div>
    </div>
  );
};

export default React.memo(MaintenanceSchedules);
